import { createContext, useContext, useState, useCallback } from "react";

const InquiryContext = createContext(null);

export function InquiryProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [presetApartmentId, setPresetApartmentId] = useState("");

  const openInquiry = useCallback((apartmentId = "") => {
    setPresetApartmentId(apartmentId || "");
    setOpen(true);
  }, []);

  const closeInquiry = useCallback(() => setOpen(false), []);

  return (
    <InquiryContext.Provider
      value={{ open, presetApartmentId, openInquiry, closeInquiry, setOpen }}
    >
      {children}
    </InquiryContext.Provider>
  );
}

export function useInquiry() {
  const ctx = useContext(InquiryContext);
  if (!ctx) throw new Error("useInquiry must be used within InquiryProvider");
  return ctx;
}
